import { Component, Host, h, Event, State, Prop, EventEmitter } from '@stencil/core'

/**
 * Represents the Newsletter Subscription Box component.
 */
@Component({
    tag: 'wf-newsletter-subscription',
    styleUrl: 'wf-newsletter-subscription.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfNewsletterSubscription {
    @Prop() couponValue = 10
    @Prop() action: string
    @Prop() csrfToken: string
    @Prop() placeholder = 'Deine E-Mail-Adresse'
    @Prop() paybackActive: boolean

    @Event({ eventName: 'newsletter-subscription-form-submitted' }) formSubmitted: EventEmitter<string>

    @State() email: string

    private form: HTMLFormElement

    /**
     * Handles submitting form.
     */
    handleSubmit = (e: Event) => {
        this.formSubmitted.emit(this.email)

        e.preventDefault()

        if (this.action?.length) {
            this.form.submit()
        }
    }

    /**
     * Handles the email value change.
     */
    handleChange = ({ target }) => {
        this.email = target.value
    }

    /**
     * @inheritDoc
     */
    render({ email, couponValue, action } = this) {
        return (
            <Host>
                <div class='content-wrapper'>
                    <div class='catch-title'>
                        <span class="catch-title-row-1">{couponValue}€</span>
                        <span class="catch-title-row-2">Gutschein</span>
                    </div>
                    <div class='newsletter-content'>
                        <div class='newsletter-content-title'>Newsletter abonnieren und Vorteile sichern:</div>
                        <div class='newsletter-content-text'>
                            <div>Aktionen & Neuheiten</div>
                            <div style={{ display: !this.paybackActive ? 'none' : 'block' }}>Aktuelle PAYBACK-Deals</div>
                            <div>Weinwissen & Empfehlungen</div>
                            <div>Updates zu WEINFREUNDE+</div>
                        </div>
                    </div>

                    <form ref={(el) => {this.form = el}} action={action} method='post' onSubmit={this.handleSubmit}>
                        <input type="hidden" name="__csrf_token" value={this.csrfToken}/>
                        <input type="hidden" name="dataSource" value="Footer"/>
                        <input
                            onInput={this.handleChange}
                            name="email"
                            type="email"
                            placeholder={this.placeholder}
                            autocomplete="email"
                            value={email}/>
                        <vx-button
                            label="Jetzt registrieren"
                            onClick={this.handleSubmit}
                            raised={true}
                            fullwidth={true}
                            aria-label="Registrierung absenden"
                            type="submit"/>
                    </form>

                </div>
                <div class="newsletter-disclaimer">
                    {/* eslint-disable-next-line max-len */}
                    Mit Klick auf "Jetzt registrieren" willige ich bis auf Widerruf ein, <a href="https://www.weinfreunde.de/datenschutz-newsletter#newsletter" target='_blank'>personalisierte Newsletter</a> der REWE Wein online GmbH ("Weinfreunde") zu erhalten. Ich bin damit einverstanden, dass die REWE Wein online GmbH mir per E-Mail an mich gerichtete Werbung zu Produkten, Dienstleistungen, Aktionen, Zufriedenheitsbefragungen und Infos zum Kundenbindungsprogramm von REWE Wein online GmbH und anderen Unternehmen der <a href="https://www.weinfreunde.de/datenschutz-newsletter#newsletter" target='_blank'>REWE Group</a> und <a href="https://www.weinfreunde.de/datenschutz-newsletter#newsletter" target='_blank'>REWE-Partnerunternehmen</a> zusendet. REWE Wein online GmbH darf zur Werbeoptimierung die Öffnung der E-Mails und Klicks auf Links erheben und analysieren. Zu diesen genannten Zwecken verarbeitet REWE Wein online GmbH meine personenbezogenen Daten, wie in den <a href="https://www.weinfreunde.de/datenschutz" target='_blank'>Datenschutzhinweisen</a> beschrieben. Diese Einwilligung kann ich jederzeit mit Wirkung für die Zukunft widerrufen, z.B. per Abmeldelink am Ende eines jeden Newsletters oder über den Kundendienst.
                </div>
            </Host>
        )
    }

}
